import { Text } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const TabSubtitle = styled(Text)<{ textColor?: string }>`
  color: ${({ textColor }) => textColor ?? '#3d4e66'};
  margin: 16px 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    margin: 32px 0 48px;
  }
`

export const TextContainer = styled.div`
  text-align: justify;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    column-count: 2;
    column-gap: 32px;
  }
`
